<div>
  <h2 mat-dialog-title class="text-black fs-3 text-center">
    {{ data.title || 'Details' }}
  </h2>
</div>

<div mat-dialog-content class="dialog-scrollable-content">
  @if (data.data.length) {
    <ul class="ps-0">
      @for (item of data.data; track item?.id || item?.email || item?.name || $index) {
        @if ((item.first_name || '').trim() || (item.last_name || '').trim()) {
          <li class="mb-3">{{ item.first_name }} {{ item.last_name }}</li>
        } @else if ((item.name || '').trim()) {
          <li class="mb-3">{{ item.name }}</li>
        } @else if ((item.email || '').trim()) {
          <li class="mb-3">{{ item.email }}</li>
        } @else {
          <li class="mb-3">{{ item }}</li>
        }
      }
    </ul>
  } @else {
    <p>No items to display.</p>
  }
</div>

<div mat-dialog-actions class="d-flex justify-content-between flex-nowrap">
  <button mat-button mat-dialog-close class="btn btn-outline-primary fs-14 rounded-1 fw-bold w-50" (click)="onCancel()">
    Close
  </button>
</div>
